import React, { useEffect, useRef } from "react";
import { useSearchStore } from "@/entities/search/model";
import { SearchInputProps } from "./search-input.props";
import { SearchInputUI } from "@/shared/ui";

export const SearchInput: React.FC<SearchInputProps> = ({ onSearch }) => {
  const searchQuery = useSearchStore((state) => state.searchQuery);
  const setSearch = useSearchStore((state) => state.setSearch);
  const isFirstRender = useRef(true);
  
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const handler = setTimeout(() => {
      onSearch(searchQuery);
    }, 400);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  const handleClear = () => {
    setSearch("");
  };

  return (
    <SearchInputUI
      value={searchQuery}
      onChange={setSearch}
      onClear={handleClear}
      placeholder="Поиск пользователей..."
    />
  );
};
